<template>
  <div>
    <div style="margin-bottom: 20px;">
      <app-button
        :label="t('Adicionar preço de adicional')"
        icon="pi pi-plus"
        size="small"
        data-testid="so-additional-service-prices-add-btn"
        @click="handleNew"
      />
    </div>

    <s-o-additional-service-prices-table
      ref="tableRef"
      @edit="handleEdit"
      @delete="handleDelete">
    </s-o-additional-service-prices-table>

    <!-- SOAdditionalServicePricesModal é centralizado no ModalManager.vue -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import SOAdditionalServicePricesTable from './SOAdditionalServicePricesTable.vue';
import { log } from '../../utils/DebugLogger';

type Id = number | string;

interface DataTableInstance {
  loadData: () => void;
}

const { t } = useI18n();

const tableRef = ref<DataTableInstance | null>(null);

const loadData = (): void => {
  log('SOAdditionalServicePricesPage', 'loadData', 'Reloading data');
  if (tableRef.value) {
    tableRef.value.loadData();
  }
};

const handleNew = (): void => {
  eventBus.emit('modal.so-additional-service-prices.open', { action: 'create' });
};

const handleEdit = (id: Id): void => {
  eventBus.emit('modal.so-additional-service-prices.open', { id, action: 'edit' });
};

const handleDelete = (id: Id, data: Record<string, unknown> | null = null): void => {
  eventBus.emit('modal.so-additional-service-prices.open', { id, data, action: 'delete' });
};

const onSaved = (): void => loadData();
const onDeleted = (): void => loadData();

onMounted(() => {
  eventBus.on('so-additional-service-prices.saved', onSaved);
  eventBus.on('so-additional-service-prices.deleted', onDeleted);
});

onBeforeUnmount(() => {
  eventBus.off('so-additional-service-prices.saved', onSaved);
  eventBus.off('so-additional-service-prices.deleted', onDeleted);
});

defineExpose({
  loadData,
  handleNew,
  handleEdit,
  handleDelete
});
</script>

<style scoped>
</style>
